import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change, OR smooth-scrolls to a #hash target when present.
// Retries briefly so anchors inside lazy-loaded page bodies (Suspense) still resolve.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace("#", ""));
      let tries = 0;
      let found = 0;
      let timer;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: found === 0 ? "smooth" : "auto", block: "start" });
          found += 1;
          // Keep correcting for ~2.5s while lazy/Suspense content above settles layout.
          if (found < 20) timer = setTimeout(tryScroll, 130);
          return;
        }
        if (tries++ < 40) timer = setTimeout(tryScroll, 100);
      };
      timer = setTimeout(tryScroll, 60);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
